import { render } from "./TopicBar.vue?vue&type=template&id=20a7796a&scoped=true"
import script from "./TopicBar.vue?vue&type=script&lang=js"
export * from "./TopicBar.vue?vue&type=script&lang=js"

import "./TopicBar.vue?vue&type=style&index=0&id=20a7796a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20a7796a"

export default script